module.exports = __webpack_public_path__ + "media/tarry stool.6c733e94.wav";